import { render } from "./UserDataTab.vue?vue&type=template&id=286cb548&scoped=true"
import script from "./UserDataTab.vue?vue&type=script&lang=js"
export * from "./UserDataTab.vue?vue&type=script&lang=js"

import "./UserDataTab.vue?vue&type=style&index=0&id=286cb548&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286cb548"]])

export default __exports__